import { useNavigate } from 'react-router-dom';
import { useRole } from '@/context/RoleContext';
import { alertLink, type DashboardAlert } from '@/utils/dashboard';

const severityStyles: Record<string, string> = {
  high: 'bg-primary-100 text-primary-700',
  medium: 'bg-secondary-100 text-secondary-800',
  low: 'bg-accent-100 text-accent-700',
};

export default function AlertsPanel({ alerts }: { alerts: DashboardAlert[] }) {
  const navigate = useNavigate();
  const { can } = useRole();
  return (
    <div className="space-y-1 p-3">
      {alerts.map((alert) => {
        const link = alertLink(alert, can);
        return (
        <button
          key={alert.id}
          type="button"
          disabled={!link}
          onClick={() => link && navigate(link)}
          className={`flex w-full items-start gap-3 rounded-md p-2 text-left ${link ? 'cursor-pointer hover:bg-background-100' : 'cursor-default'}`}
        >
          <span
            className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-md text-base ${severityStyles[alert.severity]}`}
          >
            <i className={alert.icon} />
          </span>
          <div className="min-w-0">
            <p className="text-sm font-medium text-foreground-900">{alert.title}</p>
            <p className="text-xs text-foreground-500">{alert.detail}</p>
          </div>
          {link ? <i className="ri-arrow-right-s-line ml-auto self-center text-foreground-400" /> : null}
        </button>
        );
      })}
    </div>
  );
}